var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wiki',{attrs:{"slug":_vm.slug}})
}
var staticRenderFns = []

export { render, staticRenderFns }